module.exports = __webpack_public_path__ + "img/chart-waterfall.bcb48dad.svg";